module.exports = __webpack_public_path__ + "static/media/notification-01.3580eef0.m4a";